
export default {
  data() {
    return {
      options: [
        {
          name: "icon",
          label: "Ikona",
          type: "image",
          size: "50x50",
        },
        {
          name: "link",
          label: "Poveznica",
          type: "link",
        },
      ],
    };
  },
};
